import { Dispatch, SetStateAction } from 'react';
import { Person } from '@weave/schema-gen-ts/dist/schemas/persons/v3/persons.pb';
import { Compulsory } from 'ts-toolbelt/out/Object/Compulsory';
import { contextFactory } from '@frontend/design-system';
import type { GroupThreadContext, ThreadType } from './group-types';
import type { LocationPhoneSelection, PersonPhoneSelection, ThreadHeaderSize } from './types';

export type ThreadHeaderContext = {
  personPhone: string;
  locationPhone?: LocationPhoneSelection;
  onPersonPhoneChange?: (personPhoneSelection: PersonPhoneSelection, threadId?: string) => void;
  onLocationPhoneChange?: (locationPhone: LocationPhoneSelection, threadId?: string) => void;
  groupId: string;
  variant?: ThreadHeaderSize;
  associatedContacts?: Person[];
  primaryContactId?: string;
  allowCustomPhoneNumber?: boolean;
  primaryContact?: Person;
  contextContact?: Person;
  contextPersonId?: string;
  associatedContactsDrawerIsOpen: boolean;
  setAssociatedContactsDrawerIsOpen: Dispatch<SetStateAction<boolean>>;
  /** The thread type — used to distinguish group MMS threads from standard 1:1 threads. */
  threadType?: ThreadType;
  /** Full group thread context including participants and optional group name. */
  groupThreadContext?: GroupThreadContext;
  /** True when the contact is an unsaved lead. */
  isLead?: boolean;
};

export const [ThreadHeaderContext, useThreadHeaderContext] = contextFactory<Compulsory<ThreadHeaderContext, 'variant'>>(
  'useThreadHeaderContext must be used within ThreadHeaderProvider (or ThreadHeader component)'
);
